import { AdminWorkspace } from "./AdminWorkspace.js";
import { AuthBootstrapScreen, LandingScreen, LoginScreen } from "./LoginView.js";
import { AppTopbar, Sidebar } from "./ShellChrome.js";
import { StudentWorkspace } from "./StudentWorkspace.js";
import { StudentProfileView } from "./StudentProfileView.js";
import { TeacherWorkspace } from "./TeacherWorkspace.js";
import { useSession } from "./useSession.js";

export function App() {
  const {
    adminSnapshot,
    appRoute,
    authBootstrapped,
    handleLogin,
    handleLogout,
    refreshWorkspace,
    session,
    shellView,
    showLogin,
    studentSnapshot,
    teacherSnapshot,
    workspace,
    workspaces,
    setAppRoute,
    setWorkspace
  } = useSession();

  if (shellView === "landing") {
    return <LandingScreen onLoginClick={showLogin} />;
  }

  if (!authBootstrapped && (shellView === "login" || shellView === "app")) {
    return <AuthBootstrapScreen />;
  }

  if (shellView === "login" || !session) {
    return <LoginScreen onLogin={handleLogin} />;
  }

  return (
    <>
      <AppTopbar session={session} onLogout={handleLogout} />
      <div className="fd-app-layout">
        <Sidebar workspace={workspace} workspaces={workspaces} onLogout={handleLogout} onWorkspaceChange={setWorkspace} onRouteChange={setAppRoute} />
        <main className="fd-app-main" id="dashboard">
          {workspace === "student" && appRoute === "student_profile" ? <StudentProfileView session={session} snapshot={studentSnapshot} /> : null}
          {workspace === "student" && appRoute === "dashboard" ? <StudentWorkspace snapshot={studentSnapshot} onRefresh={refreshWorkspace} /> : null}
          {workspace === "teacher" ? <TeacherWorkspace snapshot={teacherSnapshot} onRefresh={refreshWorkspace} /> : null}
          {workspace === "admin" ? <AdminWorkspace snapshot={adminSnapshot} /> : null}
        </main>
      </div>
    </>
  );
}
